/* @flow */
/**
 * index.js
 * Written by: Alex Kasemir
 */

const monthNames = [
  `Jan`, `Feb`, `Mar`,
  `Apr`, `May`, `June`, `July`,
  `Aug`, `Sep`, `Oct`,
  `Nov`, `Dec`,
];

const HORIZONTAL_ADS = [[970, 90], [728, 90], [468, 60], [320, 100], [320, 50]];
const IN_QUESTION_ADS = [[728, 90]];
const IN_QUESTION_BOTTOM_ADS = [[728, 90], [336, 280], [320, 100], [300, 250]];
const BOTTOM_ADS = [[728, 90], [300, 250]];
const DIABLO_ADS = [[728, 90], [300, 250]];
const GLOBALWIDE_ADS = [[300, 250]];
const MID_ADS = [[336, 280], [300, 250]];
const SKYSCRAPER = [[300, 600], [160, 600]];

export const SINGLE_COLUMN_BREAKPOINT = 775;

export const ROUTER_BASENAME = process.env.API_ENV === `development` ? `/staging/quizhive` : ``;


const API_BASE = process.env.API_ENV
  ? process.env.API_ENV === `development`
    ? `https://internal.minerva.dev/staging/quizhive-api`
    : `https://trivia-api.quizhive.com`
  : `http://localhost:8000`;


const LIVE_SITE = Boolean(process.env.API_ENV && process.env.NODE_ENV);

const CLOUDFRONT_URL = `https://d3r4jjji7ujr1y.cloudfront.net`;

const ALERT_AFTER = 5;

export {
  API_BASE,
  LIVE_SITE,
  HORIZONTAL_ADS,
  BOTTOM_ADS,
  MID_ADS,
  DIABLO_ADS,
  GLOBALWIDE_ADS,
  SKYSCRAPER,
  IN_QUESTION_ADS,
  IN_QUESTION_BOTTOM_ADS,
  CLOUDFRONT_URL,
  ALERT_AFTER,
};

export const hosts = {
  development: {
    cookieDomain: `localhost`,
  },
  production: {
    cookieDomain: process.env.API_ENV
      ? process.env.API_ENV === `development`
        ? `internal.minerva.dev`
        : `.quizhive.com`
      : `localhost`,
  },
}[process.env.NODE_ENV || `development`];

export const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (Math.floor(max) - Math.ceil(min))) + Math.ceil(min);
};

export const getDateString = (date) => {
  const d = new Date(date);
  return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

export const getOrdinal = (n) => {
  const s = [`th`, `st`, `nd`, `rd`];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const encodeUrl = (str) => {
  return str.replace(/\+/g, `-`).replace(/\//g, `_`).replace(/=+$/, ``);
};

export const decodeUrl = (str) => {
  const decoded = (`${str}===`).slice(0, str.length + (str.length % 4));
  return decoded.replace(/-/g, `+`).replace(/_/g, `/`);
};


export const fbEnsureInit = (callback) => {
  if (__CLIENT__ && !window.fbApiInit) {
    setTimeout(() => { fbEnsureInit(callback); }, 50);
  } else if (callback) {
    callback();
  }
};

export const ensureInWindow = (key, maxTimeout = 3000) => {
  return new Promise((resolve, reject) => {
    let waited = 0;
    const wait = (interval) => {
      setTimeout(() => { // eslint-disable-line
        waited += interval;
        if (__CLIENT__ && window[key]) {
          return resolve();
        }
        if (waited > maxTimeout) {
          return reject(`Timeout`);
        }
        wait(interval * 2);
      }, interval);
    };

    wait(15);
  });
};


export const constructURLParams = (obj) => {
  return Object.keys(obj).filter((key) => obj[key]).map((key) => {
    return [key, obj[key]].map(encodeURIComponent).join(`=`);
  }).join(`&`);
};

export const toTitleCase = (str) => {
  return str.toLowerCase().split(` `).map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
};

export const reshape = (arr, rows) => {
  const temp = [];

  for (let i = 0; i < arr.length; i += rows) {
    temp.push(arr.slice(i, i + rows));
  }

  return temp;
};

export const getWeightedRandom = (dist) => {
  const arr = [];
  Object.entries(dist).forEach(([key, val]) => {
    for (let i = 0; i < val; i += 1) {
      arr.push(key);
    }
  });

  return arr[Math.floor(Math.random() * arr.length)];
};

export const getLastElement = (arr) => arr[arr.length - 1];

export const formatAxiosError = (requestDescription, e) => {
  let errorMsg;
  if (e.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    errorMsg = `${requestDescription} request fails with status ${e.response.status}, \n
    response data: ${JSON.stringify(e.response.data)} `;
  } else if (e.request) {
    errorMsg = `${requestDescription} request was made but not response was received`;
  } else {
    // Something happened in setting up the request that triggered an Error
    errorMsg = `${requestDescription} request encountered an unexpected error, \n
    error message: ${e.message}`;
  }
  return errorMsg;
};

export default {
  API_BASE,
  getRandomInt,
  fbEnsureInit,
  constructURLParams,
  ensureInWindow,
};
